import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router'
import LoginPage from '@/pages/index.vue'
import AdminMasterLayout from "@/pages/app/administration/MasterLayout.vue";
import AdminDashboard from "@/pages/app/administration/AdminDashboard.vue";
import AdminTenantUsagePage from "@/pages/app/administration/tenant-metrics/page.vue"
import TenantAdministrationPage from "@/pages/app/administration/tenant-management/page.vue";
import { useUser } from './composables/useUser';
import { isLoggedIn } from './services/auth';


const routes: RouteRecordRaw[] = [
  { path: '/', component: LoginPage },
  {
    path: '/app',
    component: () => import('@/pages/app/layoutv2.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '/app',
        component: () => import('@/pages/app/page.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/app/dashboard',
        component: () => import('@/pages/app/page.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/app/run-analysis',
        component: () => import('@/pages/app/run-analysis/page.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/app/uploads',
        component: () => import('@/pages/app/uploads/page.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/app/data-cleaning',
        component: () => import('@/pages/app/data-cleaning/page.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/app/plotting',
        component: () => import('@/pages/app/plotting/page.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/app/tables',
        component: () => import('@/pages/app/tables/page.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/app/custom-calculations',
        component: () => import('@/pages/app/custom-calculations/page.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/app/history',
        component: () => import('@/pages/app/history/page.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: '/app/validation-history',
        component: () => import('@/pages/app/validation-history/page.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: "/app/administration",
        component: AdminMasterLayout,
        meta: { requiresAuth: true },
        children: [
          { path: "", component: AdminDashboard, meta: { requiresAuth: true } },

          { path: "tenant-metrics", component: AdminTenantUsagePage, meta: { requiresAuth: true } },
          { path: "tenant-management", component: TenantAdministrationPage, meta: { requiresAuth: true } },
          {
            path: 'tenant-management/:action/:tenantId?',
            component: () => import('@/pages/app/administration/tenant-management/tab-section/page.vue'),
            meta: { requiresAuth: true }
          }
        ],
      },
      // {
      //   path: '/app/administration',
      //   component: () => import('@/pages/app/administration/page.vue'),
      // },
      // {
      //   path: '/app/administration/tenant-metrics',
      //   component: () => import('@/pages/app/administration/tenant-metrics/page.vue'),
      // },
      // {
      //   path: '/app/administration/tenant-management',
      //   component: () => import('@/pages/app/administration/tenant-management/page.vue'),
      // },
      // {
      //   path: '/app/administration/tenant-management/:action/:tenantId?',
      //   component: () => import('@/pages/app/administration/tenant-management/tab-section/page.vue'),
      // },
      {
        path: '/app/settings',
        component: () => import('@/pages/app/settings/layout.vue'),
        meta: { requiresAuth: true },
        children: [
          {
            path: '/app/settings/profile',
            component: () => import('@/pages/app/settings/profile/page.vue'),
            meta: { requiresAuth: true }
          },
          {
            path: '/app/settings/security',
            component: () => import('@/pages/app/settings/security/page.vue'),
            meta: { requiresAuth: true }
          },
          {
            path: '/app/settings/company',
            component: () => import('@/pages/app/settings/company/page.vue'),
            meta: { requiresAuth: true }
          },
          {
            path: '/app/settings/subscription',
            component: () => import('@/pages/app/settings/subscription/page.vue'),
            meta: { requiresAuth: true }
          },
          {
            path: '/app/settings/api',
            component: () => import('@/pages/app/settings/api/page.vue'),
            meta: { requiresAuth: true }
          },
          {
            path: '/app/settings/configuration',
            component: () => import('@/pages/app/settings/configuration/page.vue'),
            meta: { requiresAuth: true, roles: ['aplos_nca:global:developer', 'aplos_nca:global:admin'] }
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: () => import('@/pages/password-help/layout.vue'),
    children: [
      {
        path: '/forgot-password',
        component: () => import('@/pages/password-help/forgot-password/page.vue')
      },
      {
        path: '/reset-password',
        component: () => import('@/pages/password-help/reset-password/page.vue')
      },

    ]
  }
];

const router = createRouter({
  routes,
  history: createWebHistory()
});


//@ts-ignore from unused
router.beforeEach(async (to, from, next) => {

  const user = useUser();
  await user.initialize();
  const loggedIn = await isLoggedIn();

  // Check if this route requires authentication
  if (to.meta.requiresAuth && !loggedIn) {
    return next({ path: '/', query: { redirect: to.fullPath } })
  }

  // Optional: check roles
  else if (Array.isArray(to?.meta?.roles) &&
    to.meta.roles.length > 0 &&
    (!Array.isArray(user.user.roles) ||
      !user.user.roles.some((role: string) => (to.meta.roles as string[]).includes(role)))) {
    return next({ path: '/app' })
  }
  
  else if (to.path === '/' && loggedIn) {
    const redirect = router.currentRoute.value.query.redirect?.toString()
    return next({ path: redirect ?? '/app' })
  }

  next()
})

// reload the app when we detect module loading issues
// this often happens after a new deployment and we've wiped
// the cache of the older version from the CDN (CloudFront)
router.onError((error, to) => {
  if (
    error.message.includes('Failed to fetch dynamically imported module') ||
    error.message.includes('Importing a module script failed')
  ) {
    if (!to?.fullPath) {
      window.location.reload();
    } else {
      try {
        window.location.href = to.fullPath;
      } catch (err) {
        console.error("error tyring to reload", err, to)
      }

    }
  } else {

    console.warn("error trying to route somehwerr", error, to)
  }
});

export default router;
